import * as PIXI from 'pixi.js'
import { DocumentType } from 'src/domain/document'

export const IDCARD_META = {
  facility: {
    size: [1600, 1036],
    backgroundUrl: 'assets/idcards/facility_dog.png',
  },
  service: {
    size: [1600, 1036],
    backgroundUrl: 'assets/idcards/service_dog.png',
  },
  service_training: {
    size: [1600, 1036],
    backgroundUrl: 'assets/idcards/service_dog_under_training.png',
  },
}

export const IDCARD_DOCUMENT_TYPE: Partial<Record<keyof typeof IDCARD_META, DocumentType>> = {
  facility: DocumentType.ADI_THERAPY_CERTIFICATES,
  service: DocumentType.ADI_SERVICE_CERTIFICATES,
}

// reverse of IDCARD_DOCUMENT_TYPE - which idcard background/type a given certificate document belongs to
export const DOCUMENT_TYPE_IDCARD: Partial<Record<DocumentType, keyof typeof IDCARD_META>> = {
  [DocumentType.ADI_THERAPY_CERTIFICATES]: 'facility',
  [DocumentType.ADI_SERVICE_CERTIFICATES]: 'service',
}

export const USER_DATA_X_POS = 480
export const USER_DATA_Y_POS = 320
export const USER_DATA_Y_DELTA = 140
export const USER_DATA_FONT_STYLE: Partial<PIXI.TextStyle> = {
  fontFamily: 'Arial',
  fontSize: 50,
  fontWeight: 'bold',
  fill: 0x000000,
  letterSpacing: 0,
}
export const USER_NAME_FONT_STYLE: Partial<PIXI.TextStyle> = {
  ...USER_DATA_FONT_STYLE,
  fontSize: 50,
}

// background width 350
export const ID_CARD_EXPIRY_TEXT_X = 120
export const ID_CARD_EXPIRY_TEXT_Y = 850

export const EXPIRY_FONT_STYLE: Partial<PIXI.TextStyle> = {
  fontFamily: 'Ariel',
  fontWeight: 'bold',
  fontSize: 65,
  fill: 0xffffff,
}

export const ID_CARD_NUMBER_FONT_STYLE: Partial<PIXI.TextStyle> = {
  fontFamily: 'Ariel',
  fontWeight: 'bolder',
  fontSize: 60,
  fill: 0xffffff,
  letterSpacing: -1,
}

export const ID_CARD_NUMBER_X = 1560
export const ID_CARD_NUMBER_Y = 223

export const DOG_PROFILE_IMG_X = 273
export const DOG_PROFILE_IMG_Y = 530
